export const getFirstChar = (value?: string) => value?.[0]?.toUpperCase() ?? "";
